import React, { useState } from "react";
import { UpdateOrders } from "../../pages";
import OrderController from "../../controllers/OrderController";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import * as yup from "yup";
import { values } from "mobx";

const UpdateOrdersContainer = ({ closeModal, data, }) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = () =>
        yup.object({
            trackingStatus: yup.string().required('Please select status'),
        });

    const onSubmit = async values => {
        const payload = {
            trackingStatus: values.trackingStatus
        }
        setLoading(true);
        const { status, errorMessage } = await OrderController.updateOrderStatus(data._id, payload);
        if (status === constant.Success) {
           await OrderController.getOrdersAnalysis()
            setLoading(false);
            MimaToastUtil.success({
                message: constant.Success,
            });
            return closeModal();
        }
        setLoading(false);
        return MimaToastUtil.error({
            message: errorMessage,
        });
    };

    const status = [
        {
            key: "DELIVERED",
            value: "DELIVERED"
        },
        {
            key: "PROCESSING",
            value: "PROCCESSING"
        },
        {
            key: "REFUNDED",
            value: "REFUNDED"
        },
        {
            key: "SHIPPED",
            value: "SHIPPED"
        },
        {
            key: "VOID",
            value: "VOID"
        }
    ]
    return (
        <UpdateOrders
            closeModal={closeModal}
            onSubmit={onSubmit}
            data={data}
            status={status}
            validationSchema={validationSchema}
            loading={loading}
        />
    )
}

export default UpdateOrdersContainer;